import { render } from "./TradeCard.vue?vue&type=template&id=4bfe2103&scoped=true&ts=true"
import script from "./TradeCard.vue?vue&type=script&lang=ts"
export * from "./TradeCard.vue?vue&type=script&lang=ts"

import "./TradeCard.vue?vue&type=style&index=0&id=4bfe2103&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfe2103"]])

export default __exports__